module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title is-1"
  }, [_vm._v("Hydroseed Estimator")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Change the values for instantly recalculated results")]), _vm._v(" "), _c('div', {
    staticClass: "columns estimator"
  }, [_c('div', {
    staticClass: "column is-one-third-desktop"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Project & Equipment Details")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label dimension-label"
  }, [_vm._v("Total Project Size")]), _vm._v(" "), _c('div', {
    staticClass: "field has-addons"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.totalProjectSize),
      expression: "totalProjectSize",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": _vm.projectSizeUnit.name
    },
    domProps: {
      "value": (_vm.totalProjectSize)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.totalProjectSize = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    domProps: {
      "value": _vm.selectedProjectSizeUnit
    },
    on: {
      "change": function($event) {
        _vm.selectedProjectSizeUnit = $event.target.value
      }
    }
  }, _vm._l((_vm.projectSizeUnits), function(unit, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(unit.name))])
  }), 0)])])])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label dimension-label"
  }, [_vm._v("Working Capacity of Tank")]), _vm._v(" "), _c('div', {
    staticClass: "field has-addons"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.tankWorkingCapacity),
      expression: "tankWorkingCapacity",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Tank size in gallons"
    },
    domProps: {
      "value": (_vm.tankWorkingCapacity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tankWorkingCapacity = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-light is-disabled",
    attrs: {
      "disabled": true
    }
  }, [_vm._v("gallons")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-third-desktop"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Mulch Application Details")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label dimension-label"
  }, [_vm._v("Target Application Rate")]), _vm._v(" "), _c('div', {
    staticClass: "field has-addons"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.mulchApplicationRate),
      expression: "mulchApplicationRate",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Pounds of mulch per acre"
    },
    domProps: {
      "value": (_vm.mulchApplicationRate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mulchApplicationRate = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-light is-disabled",
    attrs: {
      "disabled": true
    }
  }, [_vm._v("lbs/acre")])])])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label dimension-label"
  }, [_vm._v("Weight of Mulch (per bag)")]), _vm._v(" "), _c('div', {
    staticClass: "field has-addons"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.mulchBagWeight),
      expression: "mulchBagWeight",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Weight per bag of mulch"
    },
    domProps: {
      "value": (_vm.mulchBagWeight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mulchBagWeight = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-light is-disabled",
    attrs: {
      "disabled": true
    }
  }, [_vm._v("lbs")])])])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label dimension-label"
  }, [_vm._v("Mulch Mixing Rate")]), _vm._v(" "), _c('div', {
    staticClass: "field has-addons"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.mulchMixRate),
      expression: "mulchMixRate",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": "Pounds of mulch per 100 gallons"
    },
    domProps: {
      "value": (_vm.mulchMixRate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mulchMixRate = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-light is-disabled",
    attrs: {
      "disabled": true
    }
  }, [_vm._v("lbs/100 gal")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-third-desktop"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Seed Application Details")]), _vm._v(" "), _vm._l((_vm.seeds), function(seed, index) {
    return (_vm.seeds.length > 0) ? _c('div', [_c('div', [_c('div', {
      staticClass: "field has-addons"
    }, [_c('p', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.seeds[index].name),
        expression: "seeds[index].name"
      }],
      staticClass: "input label-input",
      attrs: {
        "type": "text",
        "placeholder": "Seed Name"
      },
      domProps: {
        "value": (_vm.seeds[index].name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.seeds[index], "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('button', {
      staticClass: "button is-danger",
      on: {
        "click": function($event) {
          return _vm.removeSeed(index)
        }
      }
    }, [_vm._v("delete")])])])]), _vm._v(" "), _c('div', [_c('label', {
      staticClass: "label dimension-label"
    }, [_vm._v("Target Application Rate")]), _vm._v(" "), _c('div', {
      staticClass: "field has-addons"
    }, [_c('p', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.seeds[index].applicationRate),
        expression: "seeds[index].applicationRate",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "input",
      attrs: {
        "type": "number",
        "placeholder": "Pounds of seed per acre"
      },
      domProps: {
        "value": (_vm.seeds[index].applicationRate)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.seeds[index], "applicationRate", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('button', {
      staticClass: "button is-light is-disabled",
      attrs: {
        "disabled": true
      }
    }, [_vm._v("lbs/acre")])])])]), _vm._v(" "), _c('div', [_c('label', {
      staticClass: "label dimension-label"
    }, [_vm._v("Weight of Seed (per bag)")]), _vm._v(" "), _c('div', {
      staticClass: "field has-addons"
    }, [_c('p', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.seeds[index].bagWeight),
        expression: "seeds[index].bagWeight",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "input",
      attrs: {
        "type": "number",
        "placeholder": "Weight per bag of seed"
      },
      domProps: {
        "value": (_vm.seeds[index].bagWeight)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.seeds[index], "bagWeight", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('button', {
      staticClass: "button is-light is-disabled",
      attrs: {
        "disabled": true
      }
    }, [_vm._v("lbs")])])])]), _vm._v(" "), _c('div', [_c('label', {
      staticClass: "label dimension-label"
    }, [_vm._v("Seed Mixing Rate")]), _vm._v(" "), _c('div', {
      staticClass: "field has-addons"
    }, [_c('p', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.seeds[index].mixRate),
        expression: "seeds[index].mixRate",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "input",
      attrs: {
        "type": "number",
        "placeholder": "Pounds of seed per 100 gallons"
      },
      domProps: {
        "value": (_vm.seeds[index].mixRate)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.seeds[index], "mixRate", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('button', {
      staticClass: "button is-light is-disabled",
      attrs: {
        "disabled": true
      }
    }, [_vm._v("lbs/100 gal")])])])]), _vm._v(" "), (_vm.seeds.length > 1 && index !== _vm.seeds.length - 1) ? _c('hr') : _vm._e()]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.addSeed()
      }
    }
  }, [_vm._v("Add seed type")])])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "columns estimator"
  }, [_c('div', {
    staticClass: "column is-full"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Hydro Estimate:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "is-large results"
  }, [_vm._v("\n                    Your project has an area of "), _c('strong', [_vm._v(_vm._s(_vm.results.area))]), _vm._v(" square feet.\n                ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65936eda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HydroCalculator.vue
// module id = 160
// module chunks = 1